import React from 'react';
import auth from '../api/auth';
import Dashboard from './dashboard';
import ReactTooltip from 'react-tooltip'
import Notification from './notification';
import MenuTop from './menus/menutop'
import BusyScreen from './subcomponents/busy';

class ProtectedForm extends React.Component {
    showProtected() {
        return (
            <div className="main_wrap">
                <Dashboard/>
                <ReactTooltip/>
                <Notification/>
                <MenuTop/>
                <div className="page_body_wrap">
                    <div className="page_body">
                        {this.props.children}
                    </div>
                </div>
                <BusyScreen/>
            </div>
        )
    }
    render() {
        if (auth.isAuth()) {
            return (
                this.showProtected()
            )
        } else {
            this.props.history.push('/logout');
        }
    }
}

export default ProtectedForm;